import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  HostBinding,
  Inject,
  PLATFORM_ID,
  AfterViewInit,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatMenu } from '@angular/material/menu';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FilterData } from 'interfaces/core';
import { Division, Category, Type } from 'interfaces/common';
import { DivisionService, CategoryService, TypeService } from 'services/common';
import { ReloadService } from 'services/core';
import { isPlatformBrowser } from '@angular/common';
import { AdvertStatus } from 'enum/advert-status.enum';

@Component({
  selector: 'app-search-section',
  templateUrl: './search-section.component.html',
  styleUrls: ['./search-section.component.scss'],
})
export class SearchSectionComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild('menu') private menu!: MatMenu;
  @ViewChild('categoryMenu') private categoryMenu!: MatMenu;
  @ViewChild('typeMenu') private typeMenu!: MatMenu;

  // store data
  public types: Type[] = [];
  public categories: Category[] = [];
  public searchQuery!: string;
  public divisions!: Division[];

  // Data Form
  @ViewChild('searchInput') private searchInput!: ElementRef;

  public dataForm!: FormGroup;
  // FilterData
  // TODO: Add a proper type here
  private filter: any = null;
  private isFocused = false;

  // Subscriptions
  private subDivisionData: Subscription = Subscription.EMPTY;
  private subAllType: Subscription = Subscription.EMPTY;
  private subAllCategory: Subscription = Subscription.EMPTY;

  // select location
  // TODO: Add better type
  public isSelectedValue: any;
  public isSelectedValueName?: string;

  // select category
  // TODO: Add better type
  public isSelectedValueCategory: any;
  public isSelectedValueCategoryName?: string;

  // select type
  // TODO: Add better type
  public isSelectedValueType: any;
  public isSelectedValueTypeName?: string;

  // Scrolling Text Animation
  public cityIdx = 0;
  private cities = ['Danmark', 'København', 'Aalborg', 'Odense', 'Aarhus'];
  private intervalId?: ReturnType<typeof setInterval>;

  constructor(
    private fb: FormBuilder,
    private categoryService: CategoryService,
    private typeService: TypeService,
    private divisionService: DivisionService,
    private reloadService: ReloadService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit(): void {
    this.initDataForm();
    this.getAllCategory();
    this.getAllType();
    this.getAllDivision();
  }

  ngAfterViewInit() {
    // if (isPlatformBrowser(this.platformId)) {
    //   this.intervalId = setInterval(() => {
    //     this.cityIdx = (this.cityIdx + 1) % this.cities.length;
    //   }, 4000);
    // }
  }

  private initDataForm() {
    this.dataForm = this.fb.group({
      divisions: [null],
      area: [null],
      zone: [null],
      category: [null],
      type: [null],
    });
  }

  public onSubmit() {
    console.log('Form submitted');
    const inputVal = (this.searchInput.nativeElement as HTMLInputElement).value;
    if (inputVal) return this.onSearchNavigate();

    this.router.navigate(['/ads'], {
      queryParams: {
        categories: this.dataForm?.value.category,
        types: this.dataForm?.value.type,
        divisions: this.dataForm?.value.divisions,
        area: this.dataForm?.value.area,
        zone: this.dataForm?.value.zone,
      },
      queryParamsHandling: 'merge',
    });
  }
  /**
   * HANDLE SEARCH Area
   * onClickHeader()
   * onClickSearchArea()
   * handleFocus()
   * handleOpen()
   * handleOutsideClick()
   * handleCloseOnly()
   * handleCloseAndClear()
   * onSelectItem()
   */

  public onClickSearchArea(event: MouseEvent): void {
    event.stopPropagation();
  }

  public handleFocus(): void {
    this.searchInput.nativeElement.focus();
    if (this.isFocused) return;

    this.isFocused = true;
    // const target = this.searchInput.nativeElement as HTMLInputElement;
    //target.placeholder = '';
  }

  public onSearchNavigate() {
    const inputVal = (this.searchInput.nativeElement as HTMLInputElement).value;
    if (inputVal) {
      this.router.navigate(['/ads'], {
        queryParams: { searchQuery: inputVal.trim() },
        queryParamsHandling: '',
      });
      this.searchInput.nativeElement.value = '';
      this.reloadService.needRefreshSearch$(true);
    }
  }

  public resetSearch() {
    this.searchQuery = '';
    const queryParams = { searchQuery: null };
    this.router.navigate(['/'], {
      queryParams,
      queryParamsHandling: 'merge',
    });
  }

  /**
   * HTTP REQ HANDLE
   * getAllType()
   * getAllDivision();
   */

  private getAllType() {
    const filter: FilterData = {
      filter: this.filter,
      pagination: undefined,
      sort: [{ createdAt: 'desc' }],
    };

    this.subAllType = this.typeService.getAllType(filter).subscribe({
      next: res => {
        if (res.success) {
          this.types = res.data;
        }
      },
      error: err => console.log(err),
    });
  }

  private getAllCategory() {
    const filter: FilterData = {
      sort: [{ createdAt: 'desc' }],
    };

    this.subAllCategory = this.categoryService
      .getAllCategory(filter)
      .subscribe({
        next: res => {
          if (res.success) {
            this.categories = res.data;
          }
        },
        error: err => console.log(err),
      });
  }

  private getAllDivision() {
    const mSelect = { name: true, id: true };
    const filter: FilterData = {
      filter: { status: AdvertStatus.Publish },
      select: mSelect,
      pagination: undefined,
      sort: [{ createdAt: 'asc' }],
    };

    this.subDivisionData = this.divisionService
      .getAllDivisionsdd(filter)
      .subscribe(
        res => {
          if (res.success) {
            this.divisions = res.data;
          }
        },
        err => {
          if (err) console.log(err);
        }
      );
  }

  public onSelectBtnDis(
    name = '',
    value: any,
    event: MouseEvent,
    kind: 'divisions' | 'area' | 'zone'
  ) {
    event.stopImmediatePropagation();
    this.isSelectedValue = value;
    this.isSelectedValueName = name;
    const newValues = { divisions: null, area: null, zone: null };
    newValues[kind] = this.isSelectedValue;
    this.dataForm?.patchValue(newValues);
    this.menu?.closed.emit();
  }

  public onSelectBtnCategory(name = '', value: unknown, event: MouseEvent) {
    event.stopImmediatePropagation();
    this.isSelectedValueCategory = value;
    this.isSelectedValueCategoryName = name;
    this.dataForm?.patchValue({ category: this.isSelectedValueCategory });
    this.categoryMenu.closed.emit();
  }

  public onSelectBtnType(name = '', value: unknown, event: MouseEvent) {
    event.stopImmediatePropagation();
    this.isSelectedValueType = value;
    this.isSelectedValueTypeName = name;
    this.dataForm?.patchValue({ type: this.isSelectedValueType });
    this.typeMenu.closed.emit();
  }

  @HostBinding('attr.style')
  private get cssVars() {
    return `--cities: '${this.cities.map(c => c + '\\A').join(' ')}';`;
  }

  ngOnDestroy(): void {
    this.subAllCategory.unsubscribe();
    this.subAllType.unsubscribe();
    this.subDivisionData.unsubscribe();
    clearInterval(this.intervalId);
  }
}
